<template>
    <div id="assembleSubtest">
        <div>
            <table v-if="$store.state.tryout.status != 'PUBLISHED'">
                <tr>
                    <td>
                        <app-autocomplete
                            v-if="subtestType == 'normal'"
                            :data="topics"
                            depth="2"
                            placeholder="Cari bab / sub bab ..."
                            v-on:selected="assignTopic($event)"
                            resetable="true"
                        ></app-autocomplete>
                        <app-itemchooser
                            v-if="subtestType == 'anchor'"
                            :subject="selectedSubject"
                            v-on:selected="assignAnchor($event)"
                        ></app-itemchooser>
                    </td>
                    <td>
                        <select
                            name="type"
                            class="form-control"
                            v-model="subtestType"
                        >
                            <option value="normal">Normal</option>
                            <option value="anchor">Anchor</option>
                        </select>
                    </td>
                </tr>
            </table>
        </div>
        <div>
            <table class="table table-hover">
                <tr
                    v-bind:key="index"
                    v-for="(subtestDetail, index) in details"
                >
                    <td>{{ index + 1 }}</td>
                    <td v-if="subtestDetail.is_anchor">
                        Kode Soal: {{ subtestDetail.item_code }}
                    </td>
                    <td v-else>Topik: {{ getTopicText(subtestDetail) }}</td>
                    <td
                        class="text-right"
                        v-if="$store.state.tryout.status != 'PUBLISHED'"
                    >
                        <button
                            type="button"
                            class="btn btn-success btn-small"
                            @click="moveDown(subtestDetail)"
                        >
                            <span class="fa fa-caret-down"></span>
                        </button>
                        <button
                            type="button"
                            class="btn btn-success btn-small"
                            @click="moveUp(subtestDetail)"
                        >
                            <span class="fa fa-caret-up"></span>
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger btn-small"
                            @click="remove(subtestDetail)"
                        >
                            <span class="fa fa-times"></span>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
import Autocomplete from "@/components/plugins/Autocomplete";
import ItemChooser from "@/components/plugins/ItemChooser";
import SubtestDetail from "@/components/tryout/models/SubtestDetail.js";
import ItembankService from "@/services/itembank.js";

export default {
    name: "app-assemble-subtest",
    components: {
        "app-autocomplete": Autocomplete,
        "app-itemchooser": ItemChooser,
    },
    props: {
        subject: null,
    },
    data: function () {
        return {
            showModal: false,
            details: [],
            topics: [],
            lastSequence: 0,
            subtestType: "normal",
        };
    },
    computed: {
        selectedSubject: function () {
            if (this.$store.getters.selectedSubtest) {
                var subject = {
                    nama: this.$store.getters.selectedSubtest.subject_name,
                    code: this.$store.getters.selectedSubtest.subject_code,
                    picture:
                        this.$store.getters.selectedSubtest.subject_picture,
                };

                return subject;
            }

            return this.subject;
        },
    },
    methods: {
        getTopicText: function (subtestDetail) {
            if (this.topics.length == 0) return;

            var text = "";
            var chapter = this.topics.find(function (element) {
                return element.kode == parseInt(subtestDetail.bab_code);
            });

            text += chapter.nama;

            if (subtestDetail.sub_bab_code) {
                var subChapter = chapter.subs.find(function (element) {
                    return element.kode == parseInt(subtestDetail.sub_bab_code);
                });

                text += " >> " + subChapter.nama;
            }

            return text;
        },
        assignTopic: function (selectedTopic) {
            var chapterId = selectedTopic.data[0];
            var chapter = this.topics.find(function (element) {
                return element.id == chapterId;
            });

            var detail = {};
            detail.sequence = this.lastSequence + 1;
            detail.is_anchor = false;
            detail.bab_code = chapter.kode;

            if (selectedTopic.data[1] != 0) {
                var subChapterId = selectedTopic.data[1];
                var subChapter = chapter.subs.find(function (element) {
                    return element.id == subChapterId;
                });
                detail.sub_bab_code = subChapter.kode;
            }

            detail.text = selectedTopic.text;
            var level = this.$store.state.tryout.level;
            var type = this.$store.state.tryout.type;
            var code = this.generateItemCode(
                detail.bab_code,
                detail.sub_bab_code,
                type,
                level,
            );

            var context = this;
            ItembankService.searchItemByItemCode(code, function (result) {
                if (result.success) {
                    context.details.push(detail);
                    context.lastSequence++;
                } else {
                    window.alert(
                        'Topik "' + detail.text + '" tidak memiliki soal',
                    );
                }
            });
        },
        generateItemCode: function (babCode, subBabCode, type, level) {
            var code = "";
            switch (level) {
                case "SMA":
                    code += "3";
                    break;
                case "SMP":
                    code += "2";
                    break;
                case "SD":
                    code += "1";
                    break;
                default:
                    code += "3";
            }

            switch (type) {
                case "UJIAN_AKHIR_SEKOLAH":
                    code += "3";
                    break;
                case "UJIAN_AKHIR_NASIONAL":
                    code += "2";
                    break;
                case "SBMPTN":
                    code += "1";
                    break;
                default:
                    code += "4";
            }

            code += this.subject.code;
            code += babCode;

            if (subBabCode) code += subBabCode;

            return code;
        },
        assignAnchor: function (anchorItem) {
            var detail = {};
            detail.sequence = this.lastSequence + 1;
            detail.is_anchor = true;
            detail.item_code = anchorItem.data[0];

            var found = this.details.find(function (d) {
                return d.item_code == detail.item_code;
            });

            if (!found) {
                this.details.push(detail);
                this.lastSequence++;
            }
        },
        moveUp: function (subtestDetail) {
            if (currentIndex === 0) return;
            var currentIndex = subtestDetail.sequence - 1;
            var element = this.details.splice(currentIndex, 1)[0];
            this.details.splice(currentIndex - 1, 0, element);
            this.reOrderingSequence();
        },
        moveDown: function (subtestDetail) {
            if (currentIndex === this.details.length - 1) return;
            var currentIndex = subtestDetail.sequence - 1;
            var element = this.details.splice(currentIndex, 1)[0];
            this.details.splice(currentIndex + 1, 0, element);
            this.reOrderingSequence();
        },
        remove: function (subtestDetail) {
            var confirmed = window.confirm(
                "Apakah anda yakin akan menghapus soal ini?",
            );
            if (confirmed) {
                var index = subtestDetail.sequence - 1;
                this.details.splice(index, 1);
                this.reOrderingSequence();
            }
        },
        reOrderingSequence: function () {
            var context = this;
            this.lastSequence = 0;
            this.details.forEach(function (detail) {
                detail.sequence = context.lastSequence + 1;
                context.lastSequence++;
            });
        },
        loadTopics: function () {
            var context = this;
            ItembankService.getListOfTopic(
                this.subject.code,
                function (result) {
                    if (result.success) {
                        result.data.forEach(function (topic) {
                            context.topics.push(topic);
                        });
                    }
                },
            );
        },
    },
    watch: {
        subject: function (val) {
            this.loadTopics();
        },
        details: function (val) {
            this.$emit("updated", this.details);
        },
    },
    mounted: function () {
        this.loadTopics();
        if (this.$store.getters.selectedSubtest) {
            var context = this;
            this.$store.getters.selectedSubtest.details.forEach(
                function (detail) {
                    context.details.push(detail);
                },
            );

            this.details.sort(function (a, b) {
                return a.sequence - b.sequence;
            });

            this.lastSequence = this.details.length;
        }
    },
};
</script>



// WEBPACK FOOTER //
// AssembleSubTest.vue?603434a6